import React from 'react';
import { Tooltip } from '@mui/material';
import { ArrowRightStraight } from '@components/icons/svg-icon.tsx';

const InternetProviderCardContent: React.FC<{
  item: any;
  onClick: (item: any) => void;
}> = ({ item, onClick }) => {
  return (
    <div
      className="w-full max-w-102.5 p-5 cursor-pointer border border-(--gray-alpha-600) rounded-[22px]
             transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-(--primary)
             hover:bg-linear-to-br hover:from-(--primary)/10 hover:to-(--secondary)/10"
      onClick={() => onClick(item)}
    >
      <div className="w-full flex justify-between items-start">
        <img
          src={item.image}
          alt={item.name}
          className="w-20 h-20 border border-(--gray-7) rounded-[20px] mb-4"
        />

        <ArrowRightStraight className="w-4.5! h-4.5!" strokeWidth={'1.2'} />
      </div>

      <h2 className="mb-1.25 text-[18px] font-semibold text-(--dark)">
        {item.name}
      </h2>

      <Tooltip title={item.description || ''} followCursor>
        <p className="text-sm font-normal text-[rgba(114,114,114,1)] opacity-50">
          {item.description}
        </p>
      </Tooltip>
    </div>
  );
};

export default InternetProviderCardContent;
